'use client';

import * as React from 'react';

import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from '@/components/ui/sidebar';

export function TeamSwitcher({
  teams,
}: {
  teams: {
    name: string;
    logo?: React.ElementType;
    plan: string;
  }[];
}) {
  const activeTeam = teams[0];

  if (!activeTeam) {
    return null;
  }

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <SidebarMenuButton
          asChild
          size="lg"
          tooltip={activeTeam.name}
          className="pointer-events-none border border-[var(--line)] rounded-lg"
        >
          <div
            role="group"
            tabIndex={0}
            aria-label={`${activeTeam.name} ${activeTeam.plan}`}
          >
            {/* Issue #2954: Ripia 公式 symbol (32x32)。collapsed 時は symbol のみ残る。 */}
            <img
              src="/images/logo/ripia-symbol.svg"
              alt="Ripia"
              width={32}
              height={32}
              loading="eager"
              className="size-8 shrink-0"
            />
            <div className="grid flex-1 text-left text-sm leading-tight">
              <span className="truncate font-semibold">{activeTeam.name}</span>
              <span className="truncate text-xs">{activeTeam.plan}</span>
            </div>
          </div>
        </SidebarMenuButton>
      </SidebarMenuItem>
    </SidebarMenu>
  );
}
